"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = void 0;

var react_1 = require("@emotion/react");

exports.container = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 16px;\n  bottom: 16px;\n  height: 24px;\n  padding: 0px 10px;\n  border-radius: 12px;\n  background-color: rgba(33, 37, 41, 0.8);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: -0.2px;\n  color: white;\n  text-align: center;\n  line-height: 24px;\n  z-index: 1;\n"])));